// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'rewind-solid';

export const Component = () => (
  <path d='m22.073 21.487-14.75-8.382c-.288-.239-.432-.478-.432-.814 0-.335.144-.575.432-.814l14.75-8.333c.097-.096.288-.144.527-.144.24 0 .479.096.67.288a.946.946 0 0 1 .288.67v16.715a.943.943 0 0 1-.288.67.946.946 0 0 1-.67.287c-.24 0-.431-.047-.527-.143Zm-5.891 0-14.75-8.382c-.288-.239-.432-.478-.432-.814 0-.335.144-.575.431-.814l14.751-8.333c.096-.096.288-.144.527-.144.239 0 .479.096.67.288a.946.946 0 0 1 .287.67v16.715a.946.946 0 0 1-.287.67.946.946 0 0 1-.67.287c-.24 0-.432-.047-.527-.143Z' />
);

export const viewBox = '0 0 25 25';
